import { connect } from 'react-redux';

import { getLanguage } from 'modules/language/selectors/language';

import { setVideoLayout } from '../../actions/setVideoLayout';
import { localVideoConnected, remoteVideoConnected } from '../../selectors/connectionStatus';

import VideoLayoutManager from './VideoLayoutManager';

export const mapStateToProps = (state) => ({
  switched: state.conference.consultationInfo.switchedLayout,
  localVideoConnected: localVideoConnected(state),
  remoteVideoConnected: remoteVideoConnected(state),
  language: getLanguage(),
});

export default connect(
  mapStateToProps,
  { setVideoLayout },
)(VideoLayoutManager);
